import React from 'react'
// views
import { LogicIcon, LogicSelectedIcon } from './views'
// themes
import { colors } from 'themes/index'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
import { LogicalConditionsContext } from 'containers/Risks/RiskTemplate/Edit/layers/LogicalConditions'

interface Props {
  value: string | boolean | undefined
  label?: string
  fieldId: string
}

const ConditionButton: React.FC<Props> = ({ value, label, fieldId }) => {
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const { currentCondition, setCurrentCondition } = React.useContext(LogicalConditionsContext)

  const onConditionIconClick = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    setCurrentCondition(fieldId, value, label)
  }

  const isOption = typeof value === 'string'

  if (!value || (isOption && currentCondition && currentCondition?.fieldId !== fieldId)) {
    return null
  }

  const fieldHasCondition =
    riskTemplate.formConditions?.some((cond) => cond.fieldId === fieldId) || currentCondition?.fieldId === fieldId

  const optionHasCondition =
    currentCondition?.trigger.value === value ||
    riskTemplate.formConditions?.some((cond) => cond.fieldId === fieldId && cond.trigger.value === value)

  const showLogicIcon = isOption ? !optionHasCondition : !fieldHasCondition
  const showLogicSelectedIcon = isOption ? optionHasCondition : fieldHasCondition

  return (
    <>
      {showLogicIcon && <LogicIcon onClick={onConditionIconClick} />}

      {showLogicSelectedIcon && (
        <LogicSelectedIcon
          onClick={onConditionIconClick}
          color={
            currentCondition?.fieldId === fieldId && currentCondition?.trigger.value === value
              ? colors.purple300
              : colors.black
          }
        />
      )}
    </>
  )
}

export default ConditionButton
